"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSection = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const section_1 = __importDefault(require("../section"));
const PREFIX = "PromoSection";
exports.classes = {
    title: `${PREFIX}-title`,
    subtitle: `${PREFIX}-subtitle`,
    content: `${PREFIX}-content`,
    image: `${PREFIX}-image`,
    reversed: `${PREFIX}-reversed`,
    grid: `${PREFIX}-grid`
};
exports.StyledSection = (0, styles_1.styled)(section_1.default)(({ theme }) => ({
    // NOTE: Handle PromoSection series
    "& + &": {
        paddingTop: 0,
        [`.${exports.classes.title}`]: {
            display: "none"
        },
        // NOTE: I'm sorry.
        [`.${exports.classes.subtitle}`]: {
            display: "block"
        }
    },
    [`&:nth-of-type(even), &.${exports.classes.reversed}`]: {
        [`.${exports.classes.grid}`]: {
            flexDirection: "row-reverse"
        },
        [theme.breakpoints.up("lg")]: {
            [`.${exports.classes.content}`]: {
                paddingRight: 0,
                paddingLeft: "60px"
            }
        }
    },
    // NOTE: This unfortunately is inhibited by the TableOfContents wrapper
    // in head
    "&:nth-of-type(even)": {
        backgroundColor: theme.colours.alabaster
    },
    [`.${exports.classes.subtitle}`]: {
        display: "none",
        marginBottom: "24px"
    },
    [`.${exports.classes.content}`]: {
        paddingBottom: "0",
        fontSize: "1rem",
        [theme.breakpoints.up("lg")]: {
            paddingRight: "60px"
        }
    },
    [`.${exports.classes.image}`]: {
        height: "300px",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        [theme.breakpoints.up("lg")]: {
            height: "430px"
        }
    },
    [theme.breakpoints.down("sm")]: {
        [`.${exports.classes.grid}>div:last-of-type`]: {
            marginTop: "6px"
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb21vLXNlY3Rpb24vc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlEQUE4QztBQUM5Qyx5REFBaUM7QUFFakMsTUFBTSxNQUFNLEdBQUcsY0FBYyxDQUFDO0FBRWpCLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLEtBQUssRUFBRSxHQUFHLE1BQU0sUUFBUTtJQUN4QixRQUFRLEVBQUUsR0FBRyxNQUFNLFdBQVc7SUFDOUIsT0FBTyxFQUFFLEdBQUcsTUFBTSxVQUFVO0lBQzVCLEtBQUssRUFBRSxHQUFHLE1BQU0sUUFBUTtJQUN4QixRQUFRLEVBQUUsR0FBRyxNQUFNLFdBQVc7SUFDOUIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0NBQ3ZCLENBQUM7QUFFVyxRQUFBLGFBQWEsR0FBRyxJQUFBLGVBQU0sRUFBQyxpQkFBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzNELG1DQUFtQztJQUNuQyxPQUFPLEVBQUU7UUFDUCxVQUFVLEVBQUUsQ0FBQztRQUNiLENBQUMsSUFBSSxlQUFPLENBQUMsS0FBSyxFQUFFLENBQUMsRUFBRTtZQUNyQixPQUFPLEVBQUUsTUFBTTtTQUNoQjtRQUNELG1CQUFtQjtRQUNuQixDQUFDLElBQUksZUFBTyxDQUFDLFFBQVEsRUFBRSxDQUFDLEVBQUU7WUFDeEIsT0FBTyxFQUFFLE9BQU87U0FDakI7S0FDRjtJQUNELENBQUMsMEJBQTBCLGVBQU8sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxFQUFFO1FBQzlDLENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtZQUNwQixhQUFhLEVBQUUsYUFBYTtTQUM3QjtRQUNELENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtZQUM1QixDQUFDLElBQUksZUFBTyxDQUFDLE9BQU8sRUFBRSxDQUFDLEVBQUU7Z0JBQ3ZCLFlBQVksRUFBRSxDQUFDO2dCQUNmLFdBQVcsRUFBRSxNQUFNO2FBQ3BCO1NBQ0Y7S0FDRjtJQUNELHVFQUF1RTtJQUN2RSxVQUFVO0lBQ1YscUJBQXFCLEVBQUU7UUFDckIsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsU0FBUztLQUN6QztJQUNELENBQUMsSUFBSSxlQUFPLENBQUMsUUFBUSxFQUFFLENBQUMsRUFBRTtRQUN4QixPQUFPLEVBQUUsTUFBTTtRQUNmLFlBQVksRUFBRSxNQUFNO0tBQ3JCO0lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFO1FBQ3ZCLGFBQWEsRUFBRSxHQUFHO1FBQ2xCLFFBQVEsRUFBRSxNQUFNO1FBQ2hCLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtZQUM1QixZQUFZLEVBQUUsTUFBTTtTQUNyQjtLQUNGO0lBQ0QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxLQUFLLEVBQUUsQ0FBQyxFQUFFO1FBQ3JCLE1BQU0sRUFBRSxPQUFPO1FBQ2YsY0FBYyxFQUFFLE9BQU87UUFDdkIsa0JBQWtCLEVBQUUsZUFBZTtRQUNuQyxnQkFBZ0IsRUFBRSxXQUFXO1FBQzdCLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtZQUM1QixNQUFNLEVBQUUsT0FBTztTQUNoQjtLQUNGO0lBQ0QsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1FBQzlCLENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxtQkFBbUIsQ0FBQyxFQUFFO1lBQ3JDLFNBQVMsRUFBRSxLQUFLO1NBQ2pCO0tBQ0Y7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9